<template>
  <div class="as-list"  v-loading="loading">
    <!-- 膳食记录查询月份选择 -->
    <div class="weekDate" @click="triangle='triangle_down',showDatetimePicker=true">
      {{ MonthDate }}<div :class="triangle"></div>
      <div class="recordCount">共{{mealRecordList.length}}条记录</div>
    </div>
    <div v-if="mealRecordList.length" id="content-list">
      <!-- 膳食记录列表 -->
      <div v-for="mealRecord in mealRecordList" class="mealRecordBox">
        <div class="mealRecordDate">{{mealRecord.DT}}</div>
        <div v-for="item in mealRecord.Data" class="mealTextBox">
          <span class="mealRecordText" style="color: #666666;">{{item.mealType}}：</span>
          <span v-if="(!item.mealItemName&&!item.mealPackageName) || (item.mealItemName.length===0&&item.mealPackageName.length===0)">--</span>
          <span v-for="mealItem in item.mealItemName" class="mealRecordText">{{mealItem.Name}}</span>
          <span v-for="mealPackage in item.mealPackageName" class="mealRecordText">{{mealPackage.Name}}</span>
        </div>
      </div>
    </div>
    <div v-else class="empty">
      暂无记录
    </div>
    <!-- 弹框选择要查询的膳食记录月份 -->
      <van-popup round v-model="showDatetimePicker" click-overlay="onCancelDatetimePicker" position="bottom">
        <van-datetime-picker
        type="year-month"
        v-model="currentDate"
        @confirm="onInput"
        @cancel="onCancelDatetimePicker"
      />
      </van-popup>
  </div>
</template>

<script>
import { intitime } from '@/tool'
export default {
  props: {
      activeName: {
        type: String,
        default() {
          return 'first'
        }
      }
    },
 data(){
  return {
    MealTypeArray: [],
    MonthDate: '',
    MonthFirstDate: '',
    MonthLastDate: '',
    mealRecordList: [],
    triangle: 'triangle_up',
    currentDate: new Date(),
    showDatetimePicker: false,
    loading: false
  }
 },
 // 侦听器
  watch: {
    activeName (newV, oldV) { // watch监听props里activeName的变化，然后执行操作
      console.log('newV', newV)
      if (newV === 'second') {
        this.QueryResidentElderly()
      }
    }
  },
 created(){
  this.MonthFirstDate = intitime(this.getCurrentMonthFirst(new Date().valueOf()), 'yyyy-MM-dd'),
  this.MonthLastDate = intitime(this.getCurrentMonthLast(new Date().valueOf()), 'yyyy-MM-dd')
  this.MonthDate = this.MonthFirstDate.slice(0, 7)
 },
 methods:{
  //获取膳食记录
  QueryResidentElderly() {
    this.loading = true
    this.$axios.get("/Pad/MealType").then((typeRes) => {
      const typeData = typeRes.data
      this.MealTypeArray = typeData.obj
      this.$axios.get('/Pad/ResidentElderlyMonth?profileId=' + this.$route.query.Id + '&startWeek=' + this.MonthFirstDate + '&endWeek=' + this.MonthLastDate).then((res) => {
        this.loading = false
        const data = res.data
        let mealRecordList = data.obj
        let newMealRecordList = []
        let MealTypeArray = this.MealTypeArray
        mealRecordList.forEach(val=>{
          let mealRecord = {}
          mealRecord.DT = val.DT
          mealRecord.Data = []
          let hasMeal = false
          MealTypeArray.forEach(type=>{
            let record = {}
            let index = val.Data.findIndex((item) => item.Applicablemeal === type.Id);
            if(index >= 0){
              record = val.Data[index]
            }
            record.mealType = type.Name
            mealRecord.Data.push(record)
            if ((record.mealItemName && record.mealItemName.length>0) || (record.mealPackageName&&record.mealPackageName.length>0)) {
              hasMeal = true
            }
          })
          // hasMeal=true说明有套餐或者膳食，否则过滤掉
          if(hasMeal){
            newMealRecordList.push(mealRecord)
          }
        })
        this.mealRecordList = newMealRecordList
      }).catch((err) => {
          this.loading = false
          this.$message.error({
              message:'服务器异常，稍后再试',
              offset: 100
            });
        });
    }).catch((err) => {
          this.loading = false
          this.$message.error({
              message:'服务器异常，稍后再试',
              offset: 100
            });
        });
  },
  // 根据时间戳获取每月一号
  getCurrentMonthFirst(timeStamp){
    var date = new Date(timeStamp);
    date.setDate(1);
    return date;
  },
  // 根据时间戳获取每月的最后一天
  getCurrentMonthLast(timeStamp) {
    let date = new Date(timeStamp);
    let currentMonth = date.getMonth();
    let nextMonth = ++ currentMonth;
    let nextMonthFirstDay = new Date(date.getFullYear(), nextMonth,1);
    let oneDay = 1000*60*60*24;
    return new Date(nextMonthFirstDay - oneDay);
  },
  onCancelDatetimePicker(){
    this.triangle = 'triangle_up',
    this.showDatetimePicker = false
  },
  // 选择要查询的膳食记录月份
  onInput(value) {
    console.log('event', value)
    this.MonthFirstDate = intitime(this.getCurrentMonthFirst(value), 'yyyy-MM-dd'),
    this.MonthLastDate = intitime(this.getCurrentMonthLast(value), 'yyyy-MM-dd'),
    this.currentDate = value,
    this.triangle = 'triangle_up',
    this.showDatetimePicker = false
    this.MonthDate = this.MonthFirstDate.slice(0, 7)
    this.QueryResidentElderly()
  }
 }
}
</script>

<style scoped>
.as-list {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.empty {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.weekDate{
  padding: 10px 14px;
  font-size: 14px;
  color: #333333;
  font-weight: bold;
  display: flex;
  position: relative;
}

.recordCount{
  font-weight: 400;
  color: #333333;
  position: absolute;
  right: 24px;
}

.mealRecordBox{
  width: 100%;
  margin: 0 auto;
  background-color: #FFFFFF;
  border-radius: 8px 8px 8px 8px;
  margin-bottom: 12px;
  padding: 12px 0;
}

.mealRecordDate{
  font-weight: bold;
  color: #333333;
  font-size: 14px;
  padding: 0 16px 12px 16px;
  border-bottom: solid 1px #f2f2f2;
}
.mealTextBox{
  padding: 4px 16px;
}

.mealRecordText{
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  margin-right: 4px;
}

.triangle_up{
  width: 0px;
  height: 0px;
  border: 8px solid transparent;
  border-top-color: #000000;
  position: relative;
  top: 5px;
  margin-left: 3px;
}

.triangle_down{
  width: 0px;
  height: 0px;
  border: 8px solid transparent;
  border-bottom-color: #000000;
  position: relative;
  top: -3px;
  margin-left: 3px;
  transform: rotate(360deg);
}

</style>




// WEBPACK FOOTER //
// src/components/mealsPlan/list.vue